webpackJsonp([8],{

/***/ "0ccJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/invisible.vue
//
//
//
//

/* harmony default export */ var invisible = ({
  props: {
    size: {
      type: Number,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42affba1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/invisible.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"color":"transparent","userSelect":"none"}},[_vm._v(_vm._s((new Array(_vm.size)).fill(_vm.isFullWidth ? '＿' : '_', 0).join('')))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_invisible = (esExports);
// CONCATENATED MODULE: ./src/components/tool/invisible.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  invisible,
  tool_invisible,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_invisible = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2PDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/toastMethods.vue




/* harmony default export */ var toastMethods = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addToastAction']), {
    addToast: function addToast(type, content) {
      var data = {
        type: type,
        content: content
      };
      this.addToastAction(data);
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/toastMethods.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toastMethods,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_toastMethods = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58Cw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "598Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);



var options = {
  namespace: 'vue_base_console_'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a, options);

/***/ }),

/***/ "5yC/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cduz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sortData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return imageReader; });
/* unused harmony export imageUrlReader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return downloadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fileTypeCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateFormat; });
/* unused harmony export secondFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toFormdata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return xlsxToJson; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);







var _this = this;

var sortData = function sortData(arr, keys, orders) {
  if (!arr || !(arr instanceof Array)) {
    return arr;
  }
  if (keys instanceof Object && !(keys instanceof Array)) {
    return arr;
  }
  keys = keys instanceof Array ? keys : [keys];
  orders = orders instanceof Array ? orders : [orders];
  if (keys.length <= 0) {
    return arr;
  }
  var sortBy = function sortBy(keys, orders) {
    return function (o1, o2) {
      var key = keys[0];
      var order = orders[0] !== 'desc' ? 1 : -1;
      var co1 = key instanceof Function ? key(o1) : o1[key];
      var co2 = key instanceof Function ? key(o2) : o2[key];
      co1 = co1 instanceof Array ? co1.length : co1;
      co2 = co2 instanceof Array ? co2.length : co2;
      if (co1 < co2) {
        return -1 * order;
      } else if (co1 > co2) {
        return 1 * order;
      } else {
        return keys.length === 0 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2);
      }
    };
  };
  return [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(arr)).sort(sortBy(keys, orders));
};

var imageReader = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(files) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (files) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(e) {
                    var dataUrl;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : '';

                            if (!(maxWidth || maxHeight || type === 'blob')) {
                              _context.next = 9;
                              break;
                            }

                            _context.t0 = resolve;
                            _context.next = 5;
                            return _this.imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight);

                          case 5:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);
                            _context.next = 10;
                            break;

                          case 9:
                            if (type === 'dataUrl') {
                              resolve(dataUrl);
                            } else {
                              resolve('');
                            }

                          case 10:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }();
                reader.readAsDataURL(file);
              });
            };

            content = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 7;
            _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context2.next = 19;
              break;
            }

            file = _step.value;
            _context2.t0 = content;
            _context2.next = 14;
            return getContent(file);

          case 14:
            _context2.t1 = _context2.sent;

            _context2.t0.push.call(_context2.t0, _context2.t1);

          case 16:
            _iteratorNormalCompletion = true;
            _context2.next = 9;
            break;

          case 19:
            _context2.next = 25;
            break;

          case 21:
            _context2.prev = 21;
            _context2.t2 = _context2['catch'](7);
            _didIteratorError = true;
            _iteratorError = _context2.t2;

          case 25:
            _context2.prev = 25;
            _context2.prev = 26;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 28:
            _context2.prev = 28;

            if (!_didIteratorError) {
              _context2.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context2.finish(28);

          case 32:
            return _context2.finish(25);

          case 33:
            return _context2.abrupt('return', content);

          case 34:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageReader(_x) {
    return _ref.apply(this, arguments);
  };
}();

var imageUrlReader = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(urls) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blobUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, url;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (urls) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return');

          case 2:
            getContent = function getContent(url) {
              return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                var img = new Image();
                img.onload = function (e) {
                  var canvas = document.createElement('canvas');
                  var targetWidth = img.width;
                  var targetHeight = img.height;
                  maxWidth = maxWidth || img.width;
                  maxHeight = maxHeight || img.height;
                  if (targetWidth > maxWidth || targetHeight > maxHeight) {
                    if (targetWidth / targetHeight > maxWidth / maxHeight) {
                      targetHeight = Math.round(maxWidth * (targetHeight / targetWidth));
                      targetWidth = maxWidth;
                    } else {
                      targetHeight = maxHeight;
                      targetWidth = Math.round(maxHeight * (targetWidth / targetHeight));
                    }
                  }
                  canvas.width = targetWidth;
                  canvas.height = targetHeight;
                  canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight);
                  canvas.toBlob(function (blob) {
                    if (type === 'blobUrl') {
                      resolve(URL.createObjectURL(blob));
                    } else if (type === 'blob') {
                      resolve(blob);
                    }
                  });
                };
                img.setAttribute('crossOrigin', 'Anonymous');
                img.src = url;
              });
            };

            content = [];
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context3.prev = 7;
            _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(urls);

          case 9:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context3.next = 19;
              break;
            }

            url = _step2.value;
            _context3.t0 = content;
            _context3.next = 14;
            return getContent(url);

          case 14:
            _context3.t1 = _context3.sent;

            _context3.t0.push.call(_context3.t0, _context3.t1);

          case 16:
            _iteratorNormalCompletion2 = true;
            _context3.next = 9;
            break;

          case 19:
            _context3.next = 25;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t2 = _context3['catch'](7);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t2;

          case 25:
            _context3.prev = 25;
            _context3.prev = 26;

            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }

          case 28:
            _context3.prev = 28;

            if (!_didIteratorError2) {
              _context3.next = 31;
              break;
            }

            throw _iteratorError2;

          case 31:
            return _context3.finish(28);

          case 32:
            return _context3.finish(25);

          case 33:
            return _context3.abrupt('return', content);

          case 34:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageUrlReader(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var downloadFile = function downloadFile(fileName, urlData, target) {
  var aLink = document.createElement('a');
  if (fileName) {
    aLink.download = fileName;
  }
  if (target) {
    aLink.target = target;
  }
  aLink.href = urlData;
  aLink.click();
};

var fileTypeCheck = function fileTypeCheck(e, operation, onError) {
  var acceptTypes = e.target.getAttribute('accept');
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null;
  var extension = e.target.getAttribute('extension');
  extension = extension ? extension.split(',') : null;
  var match = function match(arys, s) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(arys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var ary = _step3.value;

        var rgx = new RegExp(ary);
        if (rgx.test(s)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return false;
  };
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(e.target.files), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var file = _step4.value;

      var fileType = file.type;
      var fileExtension = file.name.split('.');
      fileExtension = fileExtension[fileExtension.length - 1];
      if (extension && !match(extension, fileExtension)) {
        e.target.value = '';
        if (onError) {
          onError(e, extension);
        }
        return;
      }
      if (acceptTypes && !match(acceptTypes, fileType)) {
        e.target.value = '';
        if (onError) {
          onError(e, acceptTypes);
        }
        return;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  operation(e);
};

var dateFormat = function dateFormat(date, fmt) {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - new Date().getTimezoneOffset()) / 60);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

var secondFormat = function secondFormat(second, fmt) {
  var o = {
    'h+': Math.floor(second / 3600),
    'm+': Math.floor(second % 3600 / 60),
    's+': Math.floor(second % 3600 % 60)
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

var toFormdata = function toFormdata(object) {
  var needEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var formData = new FormData();
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(object)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var kv = _step5.value;

      if (needEmpty || kv[1] !== null && kv[1] !== undefined) {
        if (kv[1] instanceof Array) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(kv[1]), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var data = _step6.value;

              formData.append(kv[0] + '[]', data);
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        } else {
          formData.append(kv[0], kv[1]);
        }
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return formData;
};

/* eslint-disable */
var _XLSX = XLSX;
/* eslint-enable */

var xlsxToJson = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(files) {
    var getContent, jsons, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, file;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (files) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var data = e.target.result;
                  var wb = _XLSX.read(data, {
                    type: 'binary'
                  });
                  resolve(_XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]));
                };
                reader.readAsBinaryString(file);
              });
            };

            jsons = [];
            _iteratorNormalCompletion7 = true;
            _didIteratorError7 = false;
            _iteratorError7 = undefined;
            _context4.prev = 7;
            _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
              _context4.next = 19;
              break;
            }

            file = _step7.value;
            _context4.t0 = jsons;
            _context4.next = 14;
            return getContent(file);

          case 14:
            _context4.t1 = _context4.sent;

            _context4.t0.push.call(_context4.t0, _context4.t1);

          case 16:
            _iteratorNormalCompletion7 = true;
            _context4.next = 9;
            break;

          case 19:
            _context4.next = 25;
            break;

          case 21:
            _context4.prev = 21;
            _context4.t2 = _context4['catch'](7);
            _didIteratorError7 = true;
            _iteratorError7 = _context4.t2;

          case 25:
            _context4.prev = 25;
            _context4.prev = 26;

            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }

          case 28:
            _context4.prev = 28;

            if (!_didIteratorError7) {
              _context4.next = 31;
              break;
            }

            throw _iteratorError7;

          case 31:
            return _context4.finish(28);

          case 32:
            return _context4.finish(25);

          case 33:
            return _context4.abrupt('return', jsons);

          case 34:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function xlsxToJson(_x7) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ "DBs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: function required(field) {
          return field + ' 欄位必填';
        },
        min: function min(field, args) {
          return field + ' 最少' + args + '個字';
        },
        max: function max(field, args) {
          return field + ' 不得超過' + args + '個字';
        },
        digits: function digits(field, args) {
          return field + ' 請輸入' + args + '位數字';
        },
        min_value: function min_value(field, args) {
          return field + ' 不得少於' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' 不得超過' + args;
        },
        integer: function integer(field) {
          return field + ' 必須為整數';
        },
        regex: function regex(field) {
          return '無效的 ' + field;
        },
        email: function email(field) {
          return field + ' 請輸入正確Email格式';
        },
        confirmed: function confirmed() {
          return '密碼不相符';
        },
        youtubeLink: function youtubeLink(field) {
          return field + ' 不是youtube內嵌影片連結格式';
        }
      },
      attributes: {
        account: '帳號',
        password: '密碼'
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "DVkp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "F7NO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.ae373e2.gif";

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js + 1 modules
var api = __webpack_require__("gyMJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/nullConditionalOperator.vue

/* harmony default export */ var nullConditionalOperator = ({
  methods: {
    nco: function nco(operation, _default) {
      try {
        var result = operation();
        return result !== null && result !== undefined ? result : _default;
      } catch (e) {
        return _default;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/nullConditionalOperator.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  nullConditionalOperator,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_nullConditionalOperator = (Component.exports);

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/responsitive.vue

/* harmony default export */ var responsitive = ({
  data: function data() {
    return {
      windowWidth: 0
    };
  },

  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 1070.9;
    }
  },
  created: function created() {
    var _this = this;

    var handler = function handler() {
      _this.windowWidth = window.innerWidth;
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    window.dispatchEvent(new Event('resize'));
  }
});
// CONCATENATED MODULE: ./src/mixins/responsitive.vue
var responsitive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var responsitive___vue_template__ = null
/* template functional */
var responsitive___vue_template_functional__ = false
/* styles */
var responsitive___vue_styles__ = null
/* scopeId */
var responsitive___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var responsitive___vue_module_identifier__ = null
var responsitive_Component = responsitive_normalizeComponent(
  responsitive,
  responsitive___vue_template__,
  responsitive___vue_template_functional__,
  responsitive___vue_styles__,
  responsitive___vue_scopeId__,
  responsitive___vue_module_identifier__
)

/* harmony default export */ var mixins_responsitive = (responsitive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/loginData.vue




/* harmony default export */ var loginData = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserAction', 'setLoginAction', 'setUserInfoAction']), {
    setUserData: function setUserData(response) {
      this.setUserAction(response ? response.data.user || response.data.data : null);
      this.setLoginAction(!!response);
      this.setUserInfo(response ? response.headers : null);
    },
    setUserInfo: function setUserInfo(headers) {
      if (headers && headers.uid) {
        var expiry = headers.expiry * 1000;
        var info = {
          uid: headers.uid,
          client: headers.client,
          'access-token': headers['access-token'],
          'content-type': 'application/json'
        };
        this.setUserInfoAction(info);
        this.$ls.set('userInfo', info, expiry);
      } else {
        this.setUserInfoAction(null);
        this.$ls.remove('userInfo');
      }
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/loginData.vue
var loginData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var loginData___vue_template__ = null
/* template functional */
var loginData___vue_template_functional__ = false
/* styles */
var loginData___vue_styles__ = null
/* scopeId */
var loginData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loginData___vue_module_identifier__ = null
var loginData_Component = loginData_normalizeComponent(
  loginData,
  loginData___vue_template__,
  loginData___vue_template_functional__,
  loginData___vue_styles__,
  loginData___vue_scopeId__,
  loginData___vue_module_identifier__
)

/* harmony default export */ var mixins_loginData = (loginData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/header.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var header = ({
  mixins: [mixins_nullConditionalOperator, toastMethods["a" /* default */], mixins_responsitive, mixins_loginData],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin', 'user']), {
    // static data
    functionMenu: function functionMenu() {
      var _this = this;

      return [{
        title: '訂單',
        icon: 'fa-fw fa-file',
        linkTo: { name: 'customIndex', params: { type: 'order' } },
        isLogin: true,
        role: ['admin', 'staff']
      }, {
        title: 'Kit',
        icon: 'fa-fw fa-filter',
        linkTo: { name: 'customIndex', params: { type: 'kit' } },
        isLogin: true,
        role: ['admin', 'staff']
      }, {
        title: '送樣',
        icon: 'fa-fw fa-paper-plane-o ',
        linkTo: { name: 'customIndex', params: { type: 'sampleDeliveryOrder' } },
        isLogin: true,
        role: ['admin', 'lab']
      }, {
        title: '萃取',
        icon: 'fa-fw fa-flask',
        linkTo: { name: 'customIndex', params: { type: 'extraction' } },
        isLogin: true,
        role: ['admin', 'lab']
      }, {
        title: 'Runlist',
        icon: 'fa-fw fa-registered',
        linkTo: { name: 'customIndex', params: { type: 'runlist' } },
        isLogin: true,
        role: ['admin', 'staff']
      }, {
        title: '上機',
        icon: 'fa-fw fa-database',
        linkTo: { name: 'customIndex', params: { type: 'sequencing' } },
        isLogin: true,
        role: ['admin', 'staff']
      }, {
        title: '賞金',
        icon: 'fa-fw fa-money',
        linkTo: { name: 'customIndex', params: { type: 'bountyRecommender' } },
        isLogin: true,
        role: ['admin', 'staff']
      }].filter(function (x) {
        return (x.isLogin === undefined || x.isLogin === _this.isLogin) && (x.role === undefined || x.role.includes(_this.user.role));
      });
    },
    userMenu: function userMenu() {
      var _this2 = this;

      return [{
        title: '登入',
        icon: 'fa-fw fa-sign-in',
        isLogin: false
      }, {
        title: '登出',
        icon: 'fa-fw fa-sign-out',
        isLogin: true
      }].filter(function (x) {
        return (x.isLogin === undefined || x.isLogin === _this2.isLogin) && (x.admin === undefined || x.admin === (_this2.user.role === 'role'));
      });
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction']), {
    menuButton: function menuButton(type, menu) {
      if (type === 'function') {
        switch (menu.title) {
          default:
            {}
        }
      } else if (type === 'user') {
        switch (menu.title) {
          case '登入':
            {
              this.loginClick();
              break;
            }
          case '登出':
            {
              this.logoutClick();
              break;
            }
          default:
            {}
        }
      }
    },
    loginClick: function loginClick() {
      this.setModalAction({
        action: 'login',
        width: '360px',
        param: {
          route: extends_default()({}, this.$route)
        }
      });
    },
    logoutClick: function logoutClick() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this3.$ls.get('userInfo');
                _context.next = 4;
                return Object(api["l" /* deleteUser */])(config);

              case 4:
                _this3.setUserData(null);
                _this3.$router.push({ name: 'main' });
                _this3.addToast('success', '成功訊息', '登出成功');
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this3.setLoginAction(true);
                _this3.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.errors[0]);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 9]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec1d4cb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"max-width"},[_c('div',{staticClass:"left"},[(_vm.functionMenu.length)?_c('div',{staticClass:"function-col"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"function-menu"},[_c('ul',_vm._l((_vm.functionMenu),function(menu,index){return _c('li',{key:index},[_c('hr'),_vm._v(" "),(menu.linkTo)?_c('router-link',{staticClass:"button",attrs:{"to":menu.linkTo}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])]):_c('button',{staticClass:"button",on:{"click":function($event){_vm.menuButton('function', menu)}}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])])],1)}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'main' }}},[_c('span',[_vm._v("訂單系統後台")])])],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"user-col"},[_c('button',{staticClass:"user-button"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.isLogin ? _vm.user.name : '用戶選單'))]),_vm._v(" "),_c('div',{staticClass:"icon-field"},[_c('div',{staticClass:"images",class:{ 'login': _vm.isLogin }},[(_vm.nco(function () { return _vm.user.avatar_url.length > 0; }, null))?_c('img',{attrs:{"src":_vm.user.avatar_url}}):_c('span',[_vm._v(_vm._s(_vm.nco(function () { return _vm.user.realname ? _vm.user.realname[0].toUpperCase() : _vm.user.username[0].toUpperCase(); }, '')))])])])]),_vm._v(" "),_c('div',{staticClass:"user-menu"},[_c('div',{staticClass:"menu-block"},[_c('ul',_vm._l((_vm.userMenu),function(menu,index){return _c('li',{key:index},[_c('hr'),_vm._v(" "),(menu.linkTo)?_c('router-link',{staticClass:"button",attrs:{"to":menu.linkTo}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])]):_c('button',{staticClass:"button",on:{"click":function($event){_vm.menuButton('user', menu)}}},[(menu.icon)?_c('i',{staticClass:"fa",class:menu.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(menu.title))])])],1)}),0)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"function-button"},[_c('i',{staticClass:"fa fa-bars icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("功能選單")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_header = (esExports);
// CONCATENATED MODULE: ./src/components/layout/header.vue
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = null
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_layout_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/footer.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var footer = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b9296a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"max-width"},[_c('span',[_vm._v("Footer")])])])}]
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var layout_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/layout/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  layout_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_layout_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/toast.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  computed: Object(vuex_esm["c" /* mapGetters */])(['messages']),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['deleteToastAction']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b481162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/toast.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position"},[_c('div',{staticClass:"toast-container"},[_c('transition-group',{attrs:{"name":"toastDown"}},_vm._l((_vm.messages),function(msg,index){return _c('div',{key:index + 0,staticClass:"toast"},[_c('div',{staticClass:"option"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":function (e) { return _vm.deleteToastAction(index); }}})]),_vm._v(" "),_c('div',{staticClass:"line",class:[msg.type]}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(msg.content)}})])}),0)],1)])}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var tool_toast = (toast_esExports);
// CONCATENATED MODULE: ./src/components/tool/toast.vue
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = null
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  toast,
  tool_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var components_tool_toast = (toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4b3abd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var loading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("F7NO"),"alt":""}})])])}]
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var layout_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/layout/loading.vue
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = null
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  layout_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_layout_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/uploading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var uploading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23735409","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
var uploading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var uploading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',[_vm._v("檔案上傳中")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("DVkp"),"alt":""}})])])}]
var uploading_esExports = { render: uploading_render, staticRenderFns: uploading_staticRenderFns }
/* harmony default export */ var layout_uploading = (uploading_esExports);
// CONCATENATED MODULE: ./src/components/layout/uploading.vue
var uploading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploading___vue_template_functional__ = false
/* styles */
var uploading___vue_styles__ = null
/* scopeId */
var uploading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploading___vue_module_identifier__ = null
var uploading_Component = uploading_normalizeComponent(
  uploading,
  layout_uploading,
  uploading___vue_template_functional__,
  uploading___vue_styles__,
  uploading___vue_scopeId__,
  uploading___vue_module_identifier__
)

/* harmony default export */ var components_layout_uploading = (uploading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0b09f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/loading.vue
var dialog_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var dialog_loading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("F7NO"),"alt":""}})])])}]
var dialog_loading_esExports = { render: dialog_loading_render, staticRenderFns: dialog_loading_staticRenderFns }
/* harmony default export */ var components_dialog_loading = (dialog_loading_esExports);
// CONCATENATED MODULE: ./src/components/dialog/loading.vue
var dialog_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_loading___vue_template_functional__ = false
/* styles */
var dialog_loading___vue_styles__ = null
/* scopeId */
var dialog_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_loading___vue_module_identifier__ = null
var dialog_loading_Component = dialog_loading_normalizeComponent(
  dialog_loading,
  components_dialog_loading,
  dialog_loading___vue_template_functional__,
  dialog_loading___vue_styles__,
  dialog_loading___vue_scopeId__,
  dialog_loading___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_loading = (dialog_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/container.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var container = ({
  components: {
    dialogLoading: src_components_dialog_loading
  },
  props: {
    width: {
      type: String,
      default: function _default() {
        return '400px';
      }
    },
    height: {
      type: String,
      default: function _default() {
        return 'auto';
      }
    },
    customStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isDialogLoading']), {
    containerStyle: function containerStyle() {
      return extends_default()({}, this.customStyles, { height: this.height, width: this.width });
    }
  }),
  methods: {
    closeModal: function closeModal(e) {
      if (!['modal-mask', 'modal-wrapper'].includes(e.target.className)) {
        return;
      }
      this.$emit('hide');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d03f1f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/container.vue
var container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.containerStyle)},[_vm._t("default"),_vm._v(" "),(_vm.isDialogLoading)?_c('dialogLoading'):_vm._e()],2)])])])}
var container_staticRenderFns = []
var container_esExports = { render: container_render, staticRenderFns: container_staticRenderFns }
/* harmony default export */ var dialog_container = (container_esExports);
// CONCATENATED MODULE: ./src/components/dialog/container.vue
function injectStyle (ssrContext) {
  __webpack_require__("5yC/")
}
var container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var container___vue_template_functional__ = false
/* styles */
var container___vue_styles__ = injectStyle
/* scopeId */
var container___vue_scopeId__ = "data-v-6d03f1f6"
/* moduleIdentifier (server only) */
var container___vue_module_identifier__ = null
var container_Component = container_normalizeComponent(
  container,
  dialog_container,
  container___vue_template_functional__,
  container___vue_styles__,
  container___vue_scopeId__,
  container___vue_module_identifier__
)

/* harmony default export */ var components_dialog_container = (container_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/login.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var login = ({
  mixins: [mixins_loginData, toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return { route: { name: 'main' } };
      }
    }
  },
  data: function data() {
    return {
      login: {
        email: '',
        password: ''
      },
      onSubmit: false
    };
  },

  computed: {
    disabled: function disabled() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.onSubmit) {
        value = true;
      }
      return value;
    }
  },
  methods: {
    validateUserLogin: function validateUserLogin() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!result) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.userLogin();

              case 7:
                _context.next = 10;
                break;

              case 9:
                _this.onSubmit = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    userLogin: function userLogin() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = _this2.login;
                _context2.next = 4;
                return Object(api["_2" /* postUser */])(data);

              case 4:
                response = _context2.sent;

                _this2.setUserData(response);
                _this2.clickRouter(_this2.param.route);
                _this2.addToast('success', '登入成功');
                _this2.onSubmit = false;
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](0);

                _this2.setLoginAction(false);
                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.errors[0]);
                _this2.onSubmit = false;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 11]]);
      }))();
    },
    clickRouter: function clickRouter(route) {
      this.$emit('changeModal');
      this.$router.push(route);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ced78d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content container"},[_c('table',{staticClass:"modal-form"},[_c('tr',{staticClass:"input"},[_vm._m(1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.email),expression:"login.email"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":"account","name":"account"},domProps:{"value":(_vm.login.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.validateUserLogin()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "email", $event.target.value)}}})])]),_vm._v(" "),_c('tr',{staticClass:"text"},[_vm._m(2),_vm._v(" "),_c('td',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('account')),expression:"errors.has('account')"}],staticClass:"error"},[_vm._v(_vm._s(_vm.errors.first('account')))])])]),_vm._v(" "),_c('hr',{staticClass:"no-border"}),_vm._v(" "),_c('tr',{staticClass:"input"},[_vm._m(3),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login.password),expression:"login.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"password","id":"password","name":"password"},domProps:{"value":(_vm.login.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.validateUserLogin()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.login, "password", $event.target.value)}}})])]),_vm._v(" "),_c('tr',{staticClass:"text"},[_vm._m(4),_vm._v(" "),_c('td',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"error"},[_vm._v(_vm._s(_vm.errors.first('password')))])])]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"buttons container"},[_c('button',{staticClass:"main-button field-button",class:{ 'loading': _vm.onSubmit },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.validateUserLogin()}}},[_c('i',{staticClass:"fa fa-sign-in",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("登入")])])])])}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("管理者登入")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"ti"},[_c('label',{attrs:{"for":"account"}},[_c('i',{staticClass:"fa fa-user fa-fw",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"ti"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"ti"},[_c('label',{attrs:{"for":"password"}},[_c('i',{staticClass:"fa fa-unlock-alt fa-fw",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"ti"},[_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"text"},[_c('td',{staticClass:"ti"},[_c('p')]),_vm._v(" "),_c('td',[_c('p')])])}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var dialog_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/dialog/login.vue
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = null
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  login,
  dialog_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var components_dialog_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/sticker.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var sticker = ({
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return { orders: [] };
      }
    }
  },
  data: function data() {
    return {
      position: '',
      onSubmit: false
    };
  },

  computed: {
    disabled: function disabled() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.onSubmit) {
        value = true;
      }
      return value;
    }
  },
  methods: {
    validateExportOrder: function validateExportOrder() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.next = 3;
                return _this.$validator.validateAll();

              case 3:
                result = _context.sent;

                if (!result) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.exportOrder();

              case 7:
                _context.next = 11;
                break;

              case 9:
                _this.addToast('error', '請選擇KIT列印單起始位置');
                _this.onSubmit = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    exportOrder: function exportOrder() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, data, response, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, url;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo') || {};
                data = {
                  order_ids: _this2.param.orders.map(function (order) {
                    return order.id;
                  }),
                  kit_sticker_start_position: _this2.position - 0
                };
                _context2.next = 5;
                return Object(api["C" /* getOrderExport */])(data, config);

              case 5:
                response = _context2.sent;
                result = response.data.data;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 10;

                for (_iterator = get_iterator_default()(result.signed_urls); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  url = _step.value;

                  Object(util["b" /* downloadFile */])(null, url, '_blank');
                }
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 18:
                _context2.prev = 18;
                _context2.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context2.prev = 21;

                if (!_didIteratorError) {
                  _context2.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context2.finish(21);

              case 25:
                return _context2.finish(18);

              case 26:
                _this2.onSubmit = false;
                _this2.$emit('changeModal', {}, 'exported');
                _context2.next = 34;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t1 = _context2['catch'](0);

                _this2.addToast('error', !_context2.t1.response ? _context2.t1.message : _context2.t1.response.data.errors[0]);
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 30], [10, 14, 18, 26], [19,, 21, 25]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17cd2a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/sticker.vue
var sticker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticker-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-group col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"stickerPosition"},domProps:{"value":(_vm.position)},on:{"input":function($event){if($event.target.composing){ return; }_vm.position=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"sticker-table",attrs:{"border":"1"}},_vm._l(((new Array(10)).fill('')),function(_,cindex){return _c('tr',{key:cindex},_vm._l(((new Array(3)).fill('')),function(_,rindex){return _c('td',{key:rindex,class:{ active: _vm.position === cindex * 3 + rindex + 1 },on:{"click":function (e) { return _vm.position = cindex * 3 + rindex + 1; }}},[_c('span',[_vm._v(_vm._s(cindex * 3 + rindex + 1))])])}),0)}),0)])])]),_vm._v(" "),_c('div',{staticClass:"buttons container"},[_c('button',{staticClass:"main-button field-button",class:{ 'loading': _vm.onSubmit },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.validateExportOrder()}}},[_c('span',[_vm._v("確認匯出")])])])])}
var sticker_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("選擇貼紙")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group col-xs-auto"},[_c('span',[_vm._v("請輸入KIT列印單起始位置")])])}]
var sticker_esExports = { render: sticker_render, staticRenderFns: sticker_staticRenderFns }
/* harmony default export */ var dialog_sticker = (sticker_esExports);
// CONCATENATED MODULE: ./src/components/dialog/sticker.vue
var sticker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sticker___vue_template_functional__ = false
/* styles */
var sticker___vue_styles__ = null
/* scopeId */
var sticker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sticker___vue_module_identifier__ = null
var sticker_Component = sticker_normalizeComponent(
  sticker,
  dialog_sticker,
  sticker___vue_template_functional__,
  sticker___vue_styles__,
  sticker___vue_scopeId__,
  sticker___vue_module_identifier__
)

/* harmony default export */ var components_dialog_sticker = (sticker_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/invisible.vue + 2 modules
var invisible = __webpack_require__("0ccJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/shipment.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var shipment = ({
  components: {
    invisible: invisible["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      shipmentFile: '',
      shipmentJson: null,
      onSubmit: false
    };
  },

  computed: {
    disabled: function disabled() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.onSubmit) {
        value = true;
      }
      return value;
    },
    shipmentOrderNumbers: function shipmentOrderNumbers() {
      return this.shipmentJson ? this.shipmentJson.map(function (json) {
        return json['用戶訂單號'].replace(/-(.*?)$/, '');
      }).filter(function (x, i, s) {
        return s.indexOf(x) === i;
      }) : [];
    },

    // util
    fileTypeCheck: function fileTypeCheck() {
      return util["c" /* fileTypeCheck */];
    }
  },
  methods: {
    importFileOnChange: function importFileOnChange(e) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.shipmentFile = e.target.files[0];
                _context.next = 3;
                return Object(util["g" /* xlsxToJson */])(e.target.files);

              case 3:
                _this.shipmentJson = _context.sent[0];

                e.target.value = '';

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validateImportOrder: function validateImportOrder() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.onSubmit = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (!result) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this2.importOrder();

              case 7:
                _context2.next = 11;
                break;

              case 9:
                _this2.addToast('error', '請先匯入出貨單');
                _this2.onSubmit = false;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    importOrder: function importOrder() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, file;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo') || {};
                file = _this3.shipmentFile;
                _context3.next = 5;
                return Object(api["U" /* postOrderImport */])(file, config);

              case 5:
                _this3.addToast('success', '出貨成功');
                _this3.onSubmit = false;
                _this3.$emit('changeModal', {}, 'delivered');
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                _this3.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.errors[0]);
                _this3.onSubmit = false;

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bfdc87a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/shipment.vue
var shipment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shipment-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"import","accept":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","extension":"xlsx"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.importFileOnChange(e); }, function (e, ea) { return _vm.addToast('error', '檔案格式有誤，請上傳' + ea.join('/')); }); }}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.shipmentFile),expression:"shipmentFile"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"import"},domProps:{"value":(_vm.shipmentFile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.shipmentFile=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('label',{staticClass:"mask",attrs:{"for":"import"}}),_vm._v(" "),_c('button',{staticClass:"main-button field-button"},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("匯入出貨單"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])]),_vm._v(" "),(_vm.shipmentJson)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table-line"},[_c('tr',[_c('th',[_c('center',{style:({ width: '100%' })},[_vm._v("出貨訂單號")])],1)]),_vm._v(" "),_vm._l((_vm.shipmentOrderNumbers),function(number,index){return _c('tr',{key:index},[_c('td',[_c('center',{style:({ width: '100%' })},[_vm._v(_vm._s(number))])],1)])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('button',{staticClass:"main-button field-button",class:{ 'loading': _vm.onSubmit },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.validateImportOrder()}}},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("確認出貨"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])])])}
var shipment_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("訂單出貨")])])}]
var shipment_esExports = { render: shipment_render, staticRenderFns: shipment_staticRenderFns }
/* harmony default export */ var dialog_shipment = (shipment_esExports);
// CONCATENATED MODULE: ./src/components/dialog/shipment.vue
var shipment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var shipment___vue_template_functional__ = false
/* styles */
var shipment___vue_styles__ = null
/* scopeId */
var shipment___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var shipment___vue_module_identifier__ = null
var shipment_Component = shipment_normalizeComponent(
  shipment,
  dialog_shipment,
  shipment___vue_template_functional__,
  shipment___vue_styles__,
  shipment___vue_scopeId__,
  shipment___vue_module_identifier__
)

/* harmony default export */ var components_dialog_shipment = (shipment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/electropherogramImage.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var electropherogramImage = ({
  components: {
    invisible: invisible["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      electropherogramImageFile: '',
      // electropherogramImageDataUrl: null,
      onSubmit: false
    };
  },

  computed: {
    disabled: function disabled() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.onSubmit) {
        value = true;
      }
      return value;
    },

    // util
    fileTypeCheck: function fileTypeCheck() {
      return util["c" /* fileTypeCheck */];
    }
  },
  methods: {
    importFileOnChange: function importFileOnChange(e) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.electropherogramImageFile = e.target.files[0];
                // this.electropherogramImageDataUrl = (await imageReader(e.target.files))[0]
                e.target.value = '';

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validateExtractionElectropherogramImage: function validateExtractionElectropherogramImage() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.onSubmit = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (!result) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this2.importExtractionElectropherogramImage();

              case 7:
                _context2.next = 11;
                break;

              case 9:
                _this2.addToast('error', '請先上傳檔案');
                _this2.onSubmit = false;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    importExtractionElectropherogramImage: function importExtractionElectropherogramImage() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, id, file;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo') || {};
                id = _this3.param.id;
                file = _this3.electropherogramImageFile;
                _context3.next = 6;
                return Object(api["Q" /* postExtractionElectropherogramImage */])(id, file, config);

              case 6:
                _this3.addToast('success', '上傳成功');
                _this3.onSubmit = false;
                _this3.$emit('changeModal', {}, true);
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                _this3.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.errors[0]);
                _this3.onSubmit = false;

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 11]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a70efc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/electropherogramImage.vue
var electropherogramImage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"electropherogram-image-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"import","extension":"zip,gz,7z,rar"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.importFileOnChange(e); }, function (e, ea) { return _vm.addToast('error', '檔案格式有誤，請上傳壓縮檔'); }); }}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.electropherogramImageFile),expression:"electropherogramImageFile"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"import"},domProps:{"value":(_vm.electropherogramImageFile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.electropherogramImageFile=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('label',{staticClass:"mask",attrs:{"for":"import"}}),_vm._v(" "),_c('button',{staticClass:"main-button field-button"},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("選擇檔案"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])]),_vm._v(" "),(_vm.electropherogramImageFile)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table-line"},[_c('tr',[_c('th',[_c('center',{style:({ width: '100%' })},[_vm._v("匯入檔案")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('center',{style:({ width: '100%' })},[_vm._v(_vm._s(_vm.electropherogramImageFile.name))])],1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('button',{staticClass:"main-button field-button",class:{ 'loading': _vm.onSubmit },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.validateExtractionElectropherogramImage()}}},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("上傳"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])])])}
var electropherogramImage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("上傳電泳圖")])])}]
var electropherogramImage_esExports = { render: electropherogramImage_render, staticRenderFns: electropherogramImage_staticRenderFns }
/* harmony default export */ var dialog_electropherogramImage = (electropherogramImage_esExports);
// CONCATENATED MODULE: ./src/components/dialog/electropherogramImage.vue
var electropherogramImage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var electropherogramImage___vue_template_functional__ = false
/* styles */
var electropherogramImage___vue_styles__ = null
/* scopeId */
var electropherogramImage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var electropherogramImage___vue_module_identifier__ = null
var electropherogramImage_Component = electropherogramImage_normalizeComponent(
  electropherogramImage,
  dialog_electropherogramImage,
  electropherogramImage___vue_template_functional__,
  electropherogramImage___vue_styles__,
  electropherogramImage___vue_scopeId__,
  electropherogramImage___vue_module_identifier__
)

/* harmony default export */ var components_dialog_electropherogramImage = (electropherogramImage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/sample.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var sample = ({
  components: {
    invisible: invisible["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      sampleFile: '',
      onSubmit: false
    };
  },

  computed: {
    disabled: function disabled() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.onSubmit) {
        value = true;
      }
      return value;
    },

    // util
    fileTypeCheck: function fileTypeCheck() {
      return util["c" /* fileTypeCheck */];
    }
  },
  methods: {
    importFileOnChange: function importFileOnChange(e) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.sampleFile = e.target.files[0];
                e.target.value = '';

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validateImportSample: function validateImportSample() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.onSubmit = true;
                _context2.next = 3;
                return _this2.$validator.validateAll();

              case 3:
                result = _context2.sent;

                if (!result) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this2.importSample();

              case 7:
                _context2.next = 11;
                break;

              case 9:
                _this2.addToast('error', '請先匯入檔案');
                _this2.onSubmit = false;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    importSample: function importSample() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, id, file;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo') || {};
                id = _this3.param.id;
                file = _this3.sampleFile;
                _context3.next = 6;
                return Object(api["R" /* postImportExtractionSample */])(id, file, config);

              case 6:
                _this3.addToast('success', '上傳成功');
                _this3.onSubmit = false;
                _this3.$emit('changeModal', {}, true);
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                _this3.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.errors[0]);
                _this3.onSubmit = false;

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 11]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62027bbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/sample.vue
var sample_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sample-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"import","accept":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","extension":"xlsx"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.importFileOnChange(e); }, function (e, ea) { return _vm.addToast('error', '檔案格式有誤，請上傳' + ea.join('/')); }); }}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.sampleFile),expression:"sampleFile"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"import"},domProps:{"value":(_vm.sampleFile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sampleFile=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('label',{staticClass:"mask",attrs:{"for":"import"}}),_vm._v(" "),_c('button',{staticClass:"main-button field-button"},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("匯入樣本資訊"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])]),_vm._v(" "),(_vm.sampleFile)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table-line"},[_c('tr',[_c('th',[_c('center',{style:({ width: '100%' })},[_vm._v("匯入檔案")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('center',{style:({ width: '100%' })},[_vm._v(_vm._s(_vm.sampleFile.name))])],1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('button',{staticClass:"main-button field-button",class:{ 'loading': _vm.onSubmit },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.validateImportSample()}}},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("上傳"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])])])}
var sample_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("上傳樣本資訊")])])}]
var sample_esExports = { render: sample_render, staticRenderFns: sample_staticRenderFns }
/* harmony default export */ var dialog_sample = (sample_esExports);
// CONCATENATED MODULE: ./src/components/dialog/sample.vue
var sample_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sample___vue_template_functional__ = false
/* styles */
var sample___vue_styles__ = null
/* scopeId */
var sample___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sample___vue_module_identifier__ = null
var sample_Component = sample_normalizeComponent(
  sample,
  dialog_sample,
  sample___vue_template_functional__,
  sample___vue_styles__,
  sample___vue_scopeId__,
  sample___vue_module_identifier__
)

/* harmony default export */ var components_dialog_sample = (sample_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/runlistMap.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var runlistMap = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return { orders: [] };
      }
    }
  },
  computed: {
    kitMap: function kitMap() {
      return this.param.datas.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.sequencing_plate_well_position, { replace: c.replace, number: c.extraction_plate_number, position: c.extraction_plate_well_position }));
      }, {});
    },

    // static data
    rows: function rows() {
      return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    },
    cols: function cols() {
      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    }
  },
  created: function created() {
    console.log(this.kitMap);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb25000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/runlistMap.vue
var runlistMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"runlist-map-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_c('table',{staticClass:"table-line"},_vm._l(([null].concat(_vm.cols)),function(col,cindex){return _c('tr',{key:cindex,staticClass:"none-line"},_vm._l(([null].concat(_vm.rows)),function(row,rindex){return _c('td',{key:rindex},[(!row || !col)?_c('div',[_c('center',[_c('h2',[_vm._v(_vm._s((row || col || '').replace(/^0/, '')))])])],1):_c('div',{staticClass:"circle-container"},[_c('div',{staticClass:"circle",class:{ replace: (_vm.kitMap[col + row] || {}).replace }},[((_vm.kitMap[col + row] || {}).replace)?[_c('span',[_vm._v(_vm._s((_vm.kitMap[col + row] || {}).number))]),_vm._v(" "),_c('span',[_vm._v(_vm._s((_vm.kitMap[col + row] || {}).position))])]:_vm._e()],2)])])}),0)}),0)])])}
var runlistMap_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("湊Run圖示")])])}]
var runlistMap_esExports = { render: runlistMap_render, staticRenderFns: runlistMap_staticRenderFns }
/* harmony default export */ var dialog_runlistMap = (runlistMap_esExports);
// CONCATENATED MODULE: ./src/components/dialog/runlistMap.vue
var runlistMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var runlistMap___vue_template_functional__ = false
/* styles */
var runlistMap___vue_styles__ = null
/* scopeId */
var runlistMap___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var runlistMap___vue_module_identifier__ = null
var runlistMap_Component = runlistMap_normalizeComponent(
  runlistMap,
  dialog_runlistMap,
  runlistMap___vue_template_functional__,
  runlistMap___vue_styles__,
  runlistMap___vue_scopeId__,
  runlistMap___vue_module_identifier__
)

/* harmony default export */ var components_dialog_runlistMap = (runlistMap_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/upload.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var upload = ({
  components: {
    invisible: invisible["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dataFiles: '',
      errorFileList: [],
      onSubmit: false
    };
  },

  computed: {
    disabled: function disabled() {
      var value = true;
      if (this.errors.items.length === 0) {
        value = false;
      }
      if (this.onSubmit) {
        value = true;
      }
      return value;
    },

    // util
    fileTypeCheck: function fileTypeCheck() {
      return util["c" /* fileTypeCheck */];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUploadingAction']), {
    importFileOnChange: function importFileOnChange(e) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dataFiles = from_default()(e.target.files);
                _this.errorFileList = [];
                e.target.value = '';

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validateUploadData: function validateUploadData() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.onSubmit = true;
                _this2.setUploadingAction(true);
                _context2.next = 4;
                return _this2.$validator.validateAll();

              case 4:
                result = _context2.sent;

                if (!result) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return _this2.uploadData();

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _this2.addToast('error', '請先選擇數據');
                _this2.onSubmit = false;
                _this2.setUploadingAction(false);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    uploadData: function uploadData() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var errorFileList, config, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

        return regenerator_default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                errorFileList = [];
                config = _this3.$ls.get('userInfo') || {};
                _loop = /*#__PURE__*/regenerator_default.a.mark(function _loop(file) {
                  var id;
                  return regenerator_default.a.wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          id = (_this3.param.datas.find(function (data) {
                            return data.sequencing_plate_number + data.sequencing_plate_well_position === file.name.replace(/\..+?$/, '');
                          }) || {}).id;

                          if (!id) {
                            _context3.next = 7;
                            break;
                          }

                          _context3.next = 5;
                          return Object(api["_1" /* postUploadDataKit */])(id, file, config);

                        case 5:
                          _context3.next = 8;
                          break;

                        case 7:
                          throw new Error();

                        case 8:
                          _context3.next = 13;
                          break;

                        case 10:
                          _context3.prev = 10;
                          _context3.t0 = _context3['catch'](0);

                          errorFileList.push(file);

                        case 13:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _loop, _this3, [[0, 10]]);
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 7;
                _iterator = get_iterator_default()(_this3.dataFiles);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 15;
                  break;
                }

                file = _step.value;
                return _context4.delegateYield(_loop(file), 't0', 12);

              case 12:
                _iteratorNormalCompletion = true;
                _context4.next = 9;
                break;

              case 15:
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t1 = _context4['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 21:
                _context4.prev = 21;
                _context4.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context4.prev = 24;

                if (!_didIteratorError) {
                  _context4.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context4.finish(24);

              case 28:
                return _context4.finish(21);

              case 29:
                if (!errorFileList.length) {
                  _this3.addToast('success', '上傳成功');
                  _this3.$emit('changeModal', {}, true);
                } else {
                  _this3.errorFileList = errorFileList;
                  _this3.addToast('error', '部分檔案找不到對應編號，請重新確認');
                }
                _this3.onSubmit = false;
                _this3.setUploadingAction(false);
                _context4.next = 39;
                break;

              case 34:
                _context4.prev = 34;
                _context4.t2 = _context4['catch'](0);

                _this3.addToast('error', !_context4.t2.response ? _context4.t2.message : _context4.t2.response.data.errors[0]);
                _this3.onSubmit = false;
                _this3.setUploadingAction(false);

              case 39:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee3, _this3, [[0, 34], [7, 17, 21, 29], [22,, 24, 28]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336a2148","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/upload.vue
var upload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sample-dailog dialog"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"import","extension":"zip,gz,7z,rar","multiple":"multiple"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.importFileOnChange(e); }, function (e, ea) { return _vm.addToast('error', '檔案格式有誤，請上傳壓縮檔'); }); }}}),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"model",rawName:"v-model",value:(_vm.dataFiles),expression:"dataFiles"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"import"},domProps:{"value":(_vm.dataFiles)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dataFiles=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('label',{staticClass:"mask",attrs:{"for":"import"}}),_vm._v(" "),_c('button',{staticClass:"main-button field-button"},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("選擇數據"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])]),_vm._v(" "),(_vm.dataFiles)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table-line"},[_c('tr',[_c('th',[_c('center',{style:({ width: '100%' })},[_vm._v("上傳檔案列表")])],1)]),_vm._v(" "),_vm._l((_vm.dataFiles),function(file,index){return _c('tr',{key:index},[_c('td',[_c('center',{style:({ width: '100%' })},[_c('span',{class:{ danger: _vm.errorFileList.includes(file) }},[_vm._v(_vm._s(file.name))])])],1)])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"buttons container"},[_c('button',{staticClass:"main-button field-button",class:{ 'loading': _vm.onSubmit },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.validateUploadData()}}},[_c('span',[_c('invisible',{attrs:{"size":1,"isFullWidth":true}}),_vm._v("上傳"),_c('invisible',{attrs:{"size":1,"isFullWidth":true}})],1)])])])])])])}
var upload_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("上傳數據")])])}]
var upload_esExports = { render: upload_render, staticRenderFns: upload_staticRenderFns }
/* harmony default export */ var dialog_upload = (upload_esExports);
// CONCATENATED MODULE: ./src/components/dialog/upload.vue
var upload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var upload___vue_template_functional__ = false
/* styles */
var upload___vue_styles__ = null
/* scopeId */
var upload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var upload___vue_module_identifier__ = null
var upload_Component = upload_normalizeComponent(
  upload,
  dialog_upload,
  upload___vue_template_functional__,
  upload___vue_styles__,
  upload___vue_scopeId__,
  upload___vue_module_identifier__
)

/* harmony default export */ var components_dialog_upload = (upload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/toast.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_toast = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25caf9a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/toast.vue
var dialog_toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-toast"},[_c('div',{staticClass:"line",class:[_vm.param.type]}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.param.content)}}),_vm._v(" "),_c('div',{staticClass:"button-row"},_vm._l((_vm.param.buttons || []),function(button,index){return _c('button',{key:index,staticClass:"long-button",class:[button.type + '-button'],on:{"click":function($event){_vm.$emit('changeModal', {}, button.result)}}},[_c('span',[_vm._v(_vm._s(button.title))])])}),0)])}
var dialog_toast_staticRenderFns = []
var dialog_toast_esExports = { render: dialog_toast_render, staticRenderFns: dialog_toast_staticRenderFns }
/* harmony default export */ var components_dialog_toast = (dialog_toast_esExports);
// CONCATENATED MODULE: ./src/components/dialog/toast.vue
var dialog_toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_toast___vue_template_functional__ = false
/* styles */
var dialog_toast___vue_styles__ = null
/* scopeId */
var dialog_toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_toast___vue_module_identifier__ = null
var dialog_toast_Component = dialog_toast_normalizeComponent(
  dialog_toast,
  components_dialog_toast,
  dialog_toast___vue_template_functional__,
  dialog_toast___vue_styles__,
  dialog_toast___vue_scopeId__,
  dialog_toast___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_toast = (dialog_toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// modals










__webpack_require__("5W8o");

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    layoutHeader: components_layout_header,
    layoutFooter: components_layout_footer,
    layoutToast: components_tool_toast,
    layoutLoading: components_layout_loading,
    layoutUploading: components_layout_uploading,
    // modals
    modal: components_dialog_container,
    login: components_dialog_login,
    sticker: components_dialog_sticker,
    shipment: components_dialog_shipment,
    electropherogramImage: components_dialog_electropherogramImage,
    sample: components_dialog_sample,
    runlistMap: components_dialog_runlistMap,
    upload: components_dialog_upload,
    toast: src_components_dialog_toast
  },
  mixins: [mixins_responsitive, mixins_loginData, toastMethods["a" /* default */]],
  data: function data() {
    return {
      minHeight: '300px'
    };
  },

  watch: {
    '$route': function $route() {
      var _document = document,
          body = _document.body;

      body.scroll(0, 0);
    },
    'isLogin': function isLogin(n, o) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(o !== null)) {
                  _context.next = 9;
                  break;
                }

                _this.setLoadingAction(true);
                _context.next = 4;
                return _this.preFetchDataGuest();

              case 4:
                if (!n) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.preFetchData();

              case 7:
                _this.appInitialAction(n);
                _this.setLoadingAction(false);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['normalPage', 'userPage', 'adminPage', 'staffPage', 'labPage', 'isLogin', 'isLoading', 'isDialogLoading', 'isUploading', 'modal']), {
    isMainPage: function isMainPage() {
      return ['main', ''].includes(this.$route.path.split('/')[1]);
    }
  }),
  created: function created() {
    var _this2 = this;

    this.setModalAction({});
    this.setLoadingAction(true);
    setTimeout(function () {
      return _this2.validateLogin();
    });
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    var _document2 = document,
        body = _document2.body;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var headerHeight = 60;
        var footerHeight = 0;
        var height = rect.height - headerHeight - footerHeight + 1;
        _this3.minHeight = height + 'px';
      }
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['appInitialAction', 'setLoadingAction', 'setDialogLoadingAction', 'clearLoadingAction', 'clearDialogLoadingAction', 'setModalAction'
  // global
  ]), {
    preFetchDataGuest: function preFetchDataGuest() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    preFetchData: function preFetchData() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    validateLogin: function validateLogin() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var userInfo;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userInfo = _this6.$ls.get('userInfo') || {};
                _context4.next = 3;
                return _this6.preFetchDataGuest();

              case 3:
                if (!userInfo['access-token']) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 6;
                return _this6.preFetchData();

              case 6:
                _context4.next = 8;
                return _this6.getUserByToken(userInfo);

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _this6.setUserData(null);
                _this6.appInitialAction(false);
                _this6.validateRoute(false);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getUserByToken: function getUserByToken(data) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var response, user;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return Object(api["K" /* getUserToken */])(data);

              case 3:
                response = _context5.sent;
                user = response.data.data;

                _this7.setUserData(response);
                _this7.appInitialAction(true);
                _this7.validateRoute(true, user.role, false);
                _context5.next = 16;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

                _this7.setUserData(null);
                _this7.appInitialAction(true);
                _this7.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data.errors[0]);
                _this7.validateRoute(false);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 10]]);
      }))();
    },
    validateRoute: function validateRoute(isLogin, role, admin) {
      var array = [];
      if (isLogin) {
        switch (role) {
          case 'admin':
            {
              array = lodash_default.a.union(this.adminPage, this.normalPage);
              break;
            }
          case 'staff':
            {
              array = lodash_default.a.union(this.staffPage, this.normalPage);
              break;
            }
          case 'lab':
            {
              array = lodash_default.a.union(this.labPage, this.normalPage);
              break;
            }
          default:
            {
              array = lodash_default.a.union(this.userPage, this.normalPage);
            }
        }
      } else {
        array = this.normalPage;
      }
      if (admin) {
        array = lodash_default.a.union(array, this.adminPage);
      }
      this.validateRole(isLogin, array);
    },
    validateRole: function validateRole(isLogin, pages) {
      var routeName = this.$route.name;
      if (routeName && !lodash_default.a.includes(pages, routeName)) {
        this.addToast('error', isLogin ? '權限不足' : '請先登入');
        this.$router.push({ name: 'main' });
        this.setLoadingAction(false);
      } else {
        this.setLoadingAction(false);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc910586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-root",attrs:{"id":"app"}},[_c('layout-header'),_vm._v(" "),_c('div',{staticClass:"app-container",style:({ position: _vm.modal.action && !_vm.isDialogLoading ? 'relative' : 'relative' })},[_c('div',{staticClass:"app-pages"},[_c('div',{staticClass:"app-background",class:{ filter: !_vm.isMainPage },style:({ background: '#eeeeee', backgroundSize: 'cover' })}),_vm._v(" "),_c('div',{staticClass:"max-width",style:({ minHeight: _vm.minHeight, display: _vm.isMainPage ? 'flex' : 'block', 'align-items': 'center' })},[(!_vm.isMainPage)?_c('div',{staticClass:"view-container"},[_c('div',{staticClass:"view-field responsitive-color gray-transparent"},[_c('router-view')],1)]):_c('div',{staticClass:"main-container"},[_vm._m(0)])]),_vm._v(" "),_c('layout-footer')],1)]),_vm._v(" "),_c('div',{staticClass:"modal-container"},[(_vm.modal.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal.width,"height":_vm.modal.height,"customStyles":_vm.modal.customStyles},on:{"hide":function () {
      _vm.modal.callback && _vm.modal.callback()
      _vm.setModalAction({})
    }}},[_c(_vm.modal.action,{tag:"component",attrs:{"param":_vm.modal.param},on:{"changeModal":function (option, param) {
        _vm.modal.callback && _vm.modal.callback(param)
        this$1.setModalAction(option || {})
      }}})],1):_vm._e()],1),_vm._v(" "),_c('layout-toast'),_vm._v(" "),(_vm.isLoading)?_c('layoutLoading'):_vm._e(),_vm._v(" "),(_vm.isUploading)?_c('layoutUploading'):_vm._e()],1)}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-field"},[_c('img',{attrs:{"src":__webpack_require__("jYke"),"width":"300px"}})])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("58Cw")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'main' }
  }, {
    path: '/main',
    name: 'main'
  }, {
    path: '/customIndex/:type/:state?/:dataId?',
    name: 'customIndex',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Uljn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/customEdit/:type/:id?',
    name: 'customEdit',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XzkO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/orderDetail/:id/:state?',
    name: 'orderDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("e0CP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/bountyDetail/:id/:state/:dataId',
    name: 'bountyDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GhXU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/bountyOrderDetail/:id/:state/:dataId',
    name: 'bountyOrderDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EV8E")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/kitDetail/:id/:state?',
    name: 'kitDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CgIk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '*',
    redirect: { name: 'main' }
  }]
}));
// CONCATENATED MODULE: ./src/store/modules/app.js


var _mutations;

var app_state = {
  initial: null,
  isLogin: null,
  isLoading: [],
  isDialogLoading: [],
  isUploading: [],
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  messages: [],
  // const
  normalPage: ['main'],
  userPage: [],
  adminPage: ['customIndex', 'customEdit', 'kitDetail', 'orderDetail', 'bountyDetail', 'bountyOrderDetail'],
  staffPage: ['customIndex', 'customEdit', 'kitDetail', 'orderDetail', 'bountyDetail', 'bountyOrderDetail'],
  labPage: ['customIndex', 'customEdit']
};

var getters = {
  initial: function initial(state) {
    return state.initial;
  },
  isLogin: function isLogin(state) {
    return state.isLogin;
  },
  isLoading: function isLoading(state) {
    return state.isLoading.length > 0;
  },
  isDialogLoading: function isDialogLoading(state) {
    return state.isDialogLoading.length > 0;
  },
  isUploading: function isUploading(state) {
    return state.isUploading.length > 0;
  },
  modal: function modal(state) {
    return state.modal;
  },
  messages: function messages(state) {
    return state.messages;
  },
  // const
  normalPage: function normalPage(state) {
    return state.normalPage;
  },
  userPage: function userPage(state) {
    return state.userPage;
  },
  adminPage: function adminPage(state) {
    return state.adminPage;
  },
  staffPage: function staffPage(state) {
    return state.staffPage;
  },
  labPage: function labPage(state) {
    return state.labPage;
  }
};

var types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, types.appInitial, function (state, boolean) {
  state.initial = boolean;
}), defineProperty_default()(_mutations, types.setLogin, function (state, boolean) {
  state.isLogin = boolean;
}), defineProperty_default()(_mutations, types.setLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isLoading.push('');
    } else {
      state.isLoading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.clearLoading, function (state) {
  state.isLoading = [];
}), defineProperty_default()(_mutations, types.setDialogLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isDialogLoading.push('');
    } else {
      state.isDialogLoading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.clearDialogLoading, function (state) {
  state.isDialogLoading = [];
}), defineProperty_default()(_mutations, types.setUploading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isUploading.push('');
    } else {
      state.isUploading.pop();
    }
  }
}), defineProperty_default()(_mutations, types.setModal, function (state, object) {
  state.modal = object;
}), defineProperty_default()(_mutations, types.addToast, function (state, object) {
  state.messages.push(object);
  setTimeout(function () {
    state.messages.splice(0, 1);
  }, 5000);
}), defineProperty_default()(_mutations, types.deleteToast, function (state, index) {
  state.messages.splice(index, 1);
}), _mutations);

var actions = {
  appInitialAction: function appInitialAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(types.appInitial, boolean);
  },
  setLoginAction: function setLoginAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(types.setLogin, boolean);
  },
  setLoadingAction: function setLoadingAction(_ref3, boolean) {
    var commit = _ref3.commit;

    commit(types.setLoading, boolean);
  },
  clearLoadingAction: function clearLoadingAction(_ref4) {
    var commit = _ref4.commit;

    commit(types.clearLoading);
  },
  setDialogLoadingAction: function setDialogLoadingAction(_ref5, boolean) {
    var commit = _ref5.commit;

    commit(types.setDialogLoading, boolean);
  },
  clearDialogLoadingAction: function clearDialogLoadingAction(_ref6) {
    var commit = _ref6.commit;

    commit(types.clearDialogLoading);
  },
  setUploadingAction: function setUploadingAction(_ref7, boolean) {
    var commit = _ref7.commit;

    commit(types.setUploading, boolean);
  },
  setModalAction: function setModalAction(_ref8, string) {
    var commit = _ref8.commit;

    commit(types.setModal, string);
  },
  addToastAction: function addToastAction(_ref9, object) {
    var commit = _ref9.commit;

    commit(types.addToast, object);
  },
  deleteToastAction: function deleteToastAction(_ref10, index) {
    var commit = _ref10.commit;

    commit(types.deleteToast, index);
  }
};

/* harmony default export */ var app = ({
  state: app_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/modules/global.js
var global_state = {};

var global_getters = {};

// const types = {
// }

var global_mutations = {};

var global_actions = {};

/* harmony default export */ var global = ({
  state: global_state,
  getters: global_getters,
  mutations: global_mutations,
  actions: global_actions
});
// CONCATENATED MODULE: ./src/store/modules/user.js



var user__mutations;

var user_state = {
  data: null,
  info: null
};

var user_getters = {
  user: function user(state) {
    return state.data ? extends_default()({}, state.data) : state.data;
  },
  userInfo: function userInfo(state) {
    return state.info ? extends_default()({}, state.info) : state.info;
  }
};

var user_types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
};

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, user_types.setUser, function (state, object) {
  state.data = object;
}), defineProperty_default()(user__mutations, user_types.setUserInfo, function (state, object) {
  state.info = object;
}), user__mutations);

var user_actions = {
  setUserAction: function setUserAction(_ref, object) {
    var commit = _ref.commit;

    commit(user_types.setUser, object);
  },
  setUserInfoAction: function setUserInfoAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(user_types.setUserInfo, object);
  }
};

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: app,
    global: global,
    user: modules_user
  }
}));
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






vee_validate_esm["a" /* Validator */].extend('youtubeLink', {
  getMessage: function getMessage() {
    return '';
  },
  validate: function validate(value) {
    return (/(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
    );
  }
});

__webpack_require__("DBs5");
__webpack_require__("598Q");

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// CONCATENATED MODULE: ./src/api/config.js
var TYPE = 'release';
var API_ROOT = {
  debug: 'https://api-dev.linapp.compassbioinfo.com/api/',
  release: 'https://api.linapp.compassbioinfo.com/api/'
}[TYPE];
// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./src/api/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return api_getUserToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return api_postUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return api_deleteUser; });
/* unused harmony export getDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return api_getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return api_postDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return api_putDatas; });
/* unused harmony export deleteDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return api_getOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return api_getOrder; });
/* unused harmony export postOrder */
/* unused harmony export putOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return api_deleteOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return api_getOrderExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return api_postOrderImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return api_postOrderRefund; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return api_postOrderReturn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return api_getBountys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return api_getBounty; });
/* unused harmony export postBounty */
/* unused harmony export putBounty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api_deleteBounty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return api_postRemitBounty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return api_postCancelBounty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return api_getBountyRecommenders; });
/* unused harmony export getBountyRecommender */
/* unused harmony export postBountyRecommender */
/* unused harmony export putBountyRecommender */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return api_deleteBountyRecommender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return api_getBountyOrders; });
/* unused harmony export getBountyOrder */
/* unused harmony export postBountyOrder */
/* unused harmony export putBountyOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return api_deleteBountyOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return api_getKits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return api_getKit; });
/* unused harmony export postKit */
/* unused harmony export putKit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return api_deleteKit; });
/* unused harmony export getKitSample */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return api_postJoinKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return api_postRefundKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return api_postUploadDataKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return api_getSampleDeliveryOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return api_getSampleDeliveryOrder; });
/* unused harmony export postSampleDeliveryOrder */
/* unused harmony export putSampleDeliveryOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return api_deleteSampleDeliveryOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return api_getExportSampleDeliveryOrderSample; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return api_getExportSampleDeliveryOrderSticker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return api_postConfirmSampleDeliveryOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return api_getSampleDeliveryOrderKits; });
/* unused harmony export getSampleDeliveryOrderKit */
/* unused harmony export postSampleDeliveryOrderKit */
/* unused harmony export putSampleDeliveryOrderKit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return api_deleteSampleDeliveryOrderKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return api_getExtractions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return api_getExtraction; });
/* unused harmony export postExtraction */
/* unused harmony export putExtraction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return api_deleteExtraction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return api_postExtractionElectropherogramImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return api_getExtractionElectropherogramImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return api_postImportExtractionSample; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return api_getExportExtractionSample; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return api_postExtractExtraction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return api_getExtractionKits; });
/* unused harmony export getExtractionKit */
/* unused harmony export postExtractionKit */
/* unused harmony export putExtractionKit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return api_deleteExtractionKit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return api_getRunlists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return api_getRunlist; });
/* unused harmony export postRunlist */
/* unused harmony export putRunlist */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return api_deleteRunlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return api_getExportRunlistSample; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return api_postArrangeRunlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return api_postSequencingRunlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return api_postRetrievalRunlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return api_postKitBindingRunlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return api_getRunlistKits; });
/* unused harmony export getRunlistKit */
/* unused harmony export postRunlistKit */
/* unused harmony export putRunlistKit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return api_deleteRunlistKit; });







vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);

// user
var api_getUserToken = function getUserToken(config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/order_managers/current_order_manager', { headers: config });
};
var api_postUser = function postUser(data) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/order_managers/sign_in', data);
};
var api_deleteUser = function deleteUser(config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/order_managers/sign_out', { headers: config });
};
// data
var api_getDatas = function getDatas(config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'admin/datas', { headers: config });
};
var api_getData = function getData(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'admin/datas/' + id, { headers: config });
};
var api_postDatas = function postDatas(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'admin/datas', data, { headers: config });
};
var api_putDatas = function putDatas(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'admin/datas/' + id, data, { headers: config });
};
var api_deleteDatas = function deleteDatas(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'admin/datas/' + id, { headers: config });
};
// order
var api_getOrders = function getOrders(data, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/orders', { headers: config, params: data });
};
var api_getOrder = function getOrder(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/orders/' + id, { headers: config });
};
var api_postOrder = function postOrder(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/orders', data, { headers: config });
};
var api_putOrder = function putOrder(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/orders/' + id, data, { headers: config });
};
var api_deleteOrder = function deleteOrder(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/orders/' + id, { headers: config });
};
// order operation
var api_getOrderExport = function getOrderExport(data, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/orders/export', { headers: config, params: data });
};
var api_postOrderImport = function postOrderImport(file, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/orders/import_delivered_order', Object(util["f" /* toFormdata */])({ file: file }), { headers: config });
};
var api_postOrderRefund = function postOrderRefund(id, data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/orders/' + id + '/refund', Object(util["f" /* toFormdata */])(data), { headers: config });
};
var api_postOrderReturn = function postOrderReturn(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/orders/' + id + '/return', {}, { headers: config });
};
// bounty
var api_getBountys = function getBountys(data, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/bounty_lists', { headers: config, params: extends_default()({}, data, { user_id: _this.$route.params.dataId }) });
};
var api_getBounty = function getBounty(id, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/bounty_lists/' + id, { headers: config });
};
var api_postBounty = function postBounty(data, config, _this) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/bounty_lists', data, { headers: config });
};
var api_putBounty = function putBounty(id, data, config, _this) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/bounty_lists/' + id, data, { headers: config });
};
var api_deleteBounty = function deleteBounty(id, config, _this) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/bounty_lists/' + id, { headers: config });
};
// bounty operation
var api_postRemitBounty = function postRemitBounty(id, data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/bounty_lists/' + id + '/remit', Object(util["f" /* toFormdata */])(data), { headers: config });
};
var api_postCancelBounty = function postCancelBounty(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/bounty_lists/' + id + '/cancel', {}, { headers: config });
};
// bounty recommender
var api_getBountyRecommenders = function getBountyRecommenders(data, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/bounty_lists/recommenders', { headers: config, params: { unissued: data.state ? data.state !== 'unissued' : null } });
};
var api_getBountyRecommender = function getBountyRecommender(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/bounty_lists/recommenders/' + id, { headers: config });
};
var api_postBountyRecommender = function postBountyRecommender(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/bounty_lists/recommenders', data, { headers: config });
};
var api_putBountyRecommender = function putBountyRecommender(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/bounty_lists/recommenders/' + id, data, { headers: config });
};
var api_deleteBountyRecommender = function deleteBountyRecommender(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/bounty_lists/recommenders/' + id, { headers: config });
};
// bounty recommender operation

// bounty order
var api_getBountyOrders = function getBountyOrders(data, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/bounty_lists/' + _this.$route.params.dataId + '/orders', { headers: config, params: { order_state: data.state } });
};
var api_getBountyOrder = function getBountyOrder(id, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/bounty_lists/' + _this.$route.params.dataId + '/orders/' + id, { headers: config });
};
var api_postBountyOrder = function postBountyOrder(data, config, _this) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/bounty_lists/' + _this.$route.params.dataId + '/orders', data, { headers: config });
};
var api_putBountyOrder = function putBountyOrder(id, data, config, _this) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/bounty_lists/' + _this.$route.params.dataId + '/orders/' + id, data, { headers: config });
};
var api_deleteBountyOrder = function deleteBountyOrder(id, config, _this) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/bounty_lists/' + _this.$route.params.dataId + '/orders/' + id, { headers: config });
};
// bounty order operation

// kit
var api_getKits = function getKits(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/kits', !data.state.startsWith('sp_') ? extends_default()({}, data) : extends_default()({}, data, {
    sp_qfailed_unrefunded: {
      state: 'joined_sample_delivery_order',
      qualified: false,
      refunded: false
    },
    sp_qfailed_refunded: {
      state: 'joined_sample_delivery_order',
      qualified: false,
      refunded: true
    },
    sp_sfailed_unrefunded: {
      state: 'joined_sample_delivery_order',
      sequencing_success: false,
      refunded: false
    },
    sp_sfailed_refunded: {
      state: 'joined_sample_delivery_order',
      sequencing_success: false,
      refunded: true
    }
  }[data.state]), { headers: config });
};
var api_getKit = function getKit(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/kits/' + id, { headers: config });
};
var api_postKit = function postKit(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/kits', data, { headers: config });
};
var api_putKit = function putKit(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/kits/' + id, data, { headers: config });
};
var api_deleteKit = function deleteKit(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/kits/' + id, { headers: config });
};
// kit operation
var api_getKitSample = function getKitSample(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/kits/' + id + '/sample', { headers: config });
};
var api_postJoinKit = function postJoinKit(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/kits/' + id + '/join_sample_delivery_order', {}, { headers: config });
};
var api_postRefundKit = function postRefundKit(id, data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/kits/' + id + '/refund', data, { headers: config });
};
var api_postUploadDataKit = function postUploadDataKit(id, file, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/kits/' + id + '/upload_data', Object(util["f" /* toFormdata */])({ file: file }), { headers: config });
};
// sample delivery order
var api_getSampleDeliveryOrders = function getSampleDeliveryOrders(data, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders', { headers: config, params: data });
};
var api_getSampleDeliveryOrder = function getSampleDeliveryOrder(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id, { headers: config });
};
var api_postSampleDeliveryOrder = function postSampleDeliveryOrder(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/sample_delivery_orders', data, { headers: config });
};
var api_putSampleDeliveryOrder = function putSampleDeliveryOrder(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id, data, { headers: config });
};
var api_deleteSampleDeliveryOrder = function deleteSampleDeliveryOrder(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id, { headers: config });
};
// sample delivery order operation
var api_getExportSampleDeliveryOrderSample = function getExportSampleDeliveryOrderSample(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id + '/export_samples', { headers: config });
};
var api_getExportSampleDeliveryOrderSticker = function getExportSampleDeliveryOrderSticker(id, position, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id + '/export_sticker', { headers: config, params: { sticker_start_position: position } });
};
var api_postConfirmSampleDeliveryOrder = function postConfirmSampleDeliveryOrder(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id + '/confirm_devliery', {}, { headers: config });
};
// sample delivery order kit
var api_getSampleDeliveryOrderKits = function getSampleDeliveryOrderKits(data, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + _this.$route.params.dataId + '/kits', { headers: config, params: data });
};
var api_getSampleDeliveryOrderKit = function getSampleDeliveryOrderKit(id, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + _this.$route.params.dataId + '/kits' + id, { headers: config });
};
var api_postSampleDeliveryOrderKit = function postSampleDeliveryOrderKit(data, config, _this) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + _this.$route.params.dataId + '/kits', data, { headers: config });
};
var api_putSampleDeliveryOrderKit = function putSampleDeliveryOrderKit(id, data, config, _this) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + _this.$route.params.dataId + '/kits' + id, data, { headers: config });
};
var api_deleteSampleDeliveryOrderKit = function deleteSampleDeliveryOrderKit(id, config, _this) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + _this.$route.params.dataId + '/kits' + id, { headers: config });
};
// sample delivery order kit operation

// extraction
var api_getExtractions = function getExtractions(data, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/extraction/sample_delivery_orders', { headers: config, params: data });
};
var api_getExtraction = function getExtraction(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/extraction/' + id, { headers: config });
};
var api_postExtraction = function postExtraction(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/extraction', data, { headers: config });
};
var api_putExtraction = function putExtraction(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/extraction/' + id, data, { headers: config });
};
var api_deleteExtraction = function deleteExtraction(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/extraction/' + id, { headers: config });
};
// extraction operation
var api_postExtractionElectropherogramImage = function postExtractionElectropherogramImage(id, file, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/extraction/' + id + '/electropherogram_images', Object(util["f" /* toFormdata */])({ file: file }), { headers: config });
};
var api_getExtractionElectropherogramImage = function getExtractionElectropherogramImage(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/extraction/' + id + '/electropherogram_images', { headers: config });
};
var api_postImportExtractionSample = function postImportExtractionSample(id, file, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/extraction/' + id + '/import_samples', Object(util["f" /* toFormdata */])({ file: file }), { headers: config });
};
var api_getExportExtractionSample = function getExportExtractionSample(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/sample_delivery_orders/' + id + '/export_samples', { headers: config });
};
var api_postExtractExtraction = function postExtractExtraction(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/extraction/' + id + '/extract', {}, { headers: config });
};
// extraction kit
var api_getExtractionKits = function getExtractionKits(data, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/extraction/' + _this.$route.params.dataId + '/kits', { headers: config, params: data });
};
var api_getExtractionKit = function getExtractionKit(id, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/extraction/' + _this.$route.params.dataId + '/kits' + id, { headers: config });
};
var api_postExtractionKit = function postExtractionKit(data, config, _this) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/extraction/' + _this.$route.params.dataId + '/kits', data, { headers: config });
};
var api_putExtractionKit = function putExtractionKit(id, data, config, _this) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/extraction/' + _this.$route.params.dataId + '/kits' + id, data, { headers: config });
};
var api_deleteExtractionKit = function deleteExtractionKit(id, config, _this) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/extraction/' + _this.$route.params.dataId + '/kits' + id, { headers: config });
};
// extraction kit operation

// runlist
var api_getRunlists = function getRunlists(data, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/runlists', { headers: config, params: data });
};
var api_getRunlist = function getRunlist(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/runlists/' + id, { headers: config });
};
var api_postRunlist = function postRunlist(data, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/runlists', data, { headers: config });
};
var api_putRunlist = function putRunlist(id, data, config) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/runlists/' + id, data, { headers: config });
};
var api_deleteRunlist = function deleteRunlist(id, config) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/runlists/' + id, { headers: config });
};
// runlist operation
var api_getExportRunlistSample = function getExportRunlistSample(id, config) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/runlists/' + id + '/export_samples', { headers: config });
};
var api_postArrangeRunlist = function postArrangeRunlist(ids, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/runlists/arrange', { runlist_ids: ids }, { headers: config });
};
var api_postSequencingRunlist = function postSequencingRunlist(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/runlists/' + id + '/confirm_sequencing', {}, { headers: config });
};
var api_postRetrievalRunlist = function postRetrievalRunlist(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/runlists/' + id + '/confirm_data_retrieval', {}, { headers: config });
};
var api_postKitBindingRunlist = function postKitBindingRunlist(id, config) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/runlists/' + id + '/complete_kits_binding', {}, { headers: config });
};
// runlist kit
var api_getRunlistKits = function getRunlistKits(data, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/runlists/' + _this.$route.params.dataId + '/kits', { headers: config, params: data });
};
var api_getRunlistKit = function getRunlistKit(id, config, _this) {
  return vue_esm["a" /* default */].axios.get(API_ROOT + 'v1/order_admin/runlists/' + _this.$route.params.dataId + '/kits' + id, { headers: config });
};
var api_postRunlistKit = function postRunlistKit(data, config, _this) {
  return vue_esm["a" /* default */].axios.post(API_ROOT + 'v1/order_admin/runlists/' + _this.$route.params.dataId + '/kits', data, { headers: config });
};
var api_putRunlistKit = function putRunlistKit(id, data, config, _this) {
  return vue_esm["a" /* default */].axios.put(API_ROOT + 'v1/order_admin/runlists/' + _this.$route.params.dataId + '/kits' + id, data, { headers: config });
};
var api_deleteRunlistKit = function deleteRunlistKit(id, config, _this) {
  return vue_esm["a" /* default */].axios.delete(API_ROOT + 'v1/order_admin/runlists/' + _this.$route.params.dataId + '/kits' + id, { headers: config });
};
// runlist kit operation

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "jYke":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.3b6b67e.png";

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.292c24720fa40318de33.js